export const IconDelivery = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 19C9.10457 19 10 18.1046 10 17C10 15.8954 9.10457 15 8 15C6.89543 15 6 15.8954 6 17C6 18.1046 6.89543 19 8 19Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0005 19C19.1051 19 20.0005 18.1046 20.0005 17C20.0005 15.8954 19.1051 15 18.0005 15C16.8959 15 16.0005 15.8954 16.0005 17C16.0005 18.1046 16.8959 19 18.0005 19Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0505 17H15.0005V6.6C15.0005 6.26863 14.7319 6 14.4005 6H1.00049"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M5.65 17H3.6C3.26863 17 3 16.7314 3 16.4V11.5"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M1.99951 9H5.99951"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9H20.6101C20.8472 9 21.0621 9.13964 21.1584 9.35632L22.9483 13.3836C22.9824 13.4604 23 13.5434 23 13.6273V16.4C23 16.7314 22.7314 17 22.4 17H20.5"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M15 17H16"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
    </svg>
  );
};
